<!-- PRINT CHIMP UNIVERSAL WORKWEAR BUILDER — BLOCK 2 — V3.33 LEAN 4-IMAGE TRADE GALLERY -->
(function(){
 const R=document.getElementById('pc-workwear-builder'); if(!R)return;
 const $=(s,c=R)=>c.querySelector(s), $$=(s,c=R)=>Array.from(c.querySelectorAll(s));
 const money=n=>'£'+Number(n||0).toFixed(2);

 const CATALOG={
  tshirts:{
   label:'T-Shirts', singular:'T-Shirt', start:'tshirts', icon:'tee',
   eyebrow:'TURN EVERY JOB INTO AN ADVERT FOR YOUR BUSINESS',
   title:'BUILD YOUR T-SHIRTS',
   copy:"Look professional in front of customers and keep your business visible while you're working.",
   standard:{handle:'standard-workwear-t-shirt',base:3.95},
   premium:{handle:'premium-workwear-t-shirt',base:5.95},
   cool:{handle:'cool-performance-workwear-t-shirt',base:5.50}
  },
  polos:{
   label:'Polos',singular:'Polo',start:'polos',icon:'polo',
   eyebrow:"MAKE THE RIGHT IMPRESSION BEFORE YOU'VE SAID A WORD",
   title:'BUILD YOUR POLOS',
   copy:'A smarter workwear option for quotations, customer visits and everyday jobs.',
   standard:{handle:'standard-workwear-polo',base:7.95},
   premium:{handle:'premium-workwear-polo',base:11.95}
  },
  hoodies:{
   label:'Hoodies',singular:'Hoodie',start:'hoodies',icon:'hoodie',
   eyebrow:'STAY WARM. KEEP YOUR BUSINESS VISIBLE.',
   title:'BUILD YOUR HOODIES',
   copy:'Layer up without covering up the business customers need to remember.',
   standard:{handle:'standard-workwear-hoodie',base:13.85},
   premium:{handle:'premium-workwear-hoodie',base:24.95}
  },
  sweatshirts:{
   label:'Sweatshirts',singular:'Sweatshirt',start:'sweatshirts',icon:'sweatshirt',
   eyebrow:'LOOK PROFESSIONAL WHEN YOU LAYER UP',
   title:'BUILD YOUR SWEATSHIRTS',
   copy:'Practical branded layers that keep the whole team looking consistent.',
   standard:{handle:'standard-workwear-sweatshirt',base:11.95},
   premium:{handle:'premium-workwear-sweatshirt',base:20.95}
  },
  softshells:{
   label:'Softshells',singular:'Softshell',start:'softshells',icon:'softshell',
   eyebrow:'LOOK ESTABLISHED BEFORE YOU EVEN KNOCK',
   title:'BUILD YOUR SOFTSHELLS',
   copy:'A smarter outer layer that keeps your business looking professional outdoors and in front of customers.',
   standard:{handle:'standard-workwear-softshell',base:22.95},
   premium:{handle:'premium-workwear-softshell',base:45.00}
  },
  hivis:{
   label:'Hi-Vis',singular:'Hi-Vis Vest',start:'hivis',icon:'hivis',
   eyebrow:'STAY VISIBLE. KEEP YOUR BRAND VISIBLE.',
   title:'BUILD YOUR HI-VIS',
   copy:'Keep the team visible on site while keeping your business visible too.',
   standard:{handle:'standard-high-vis-vest',base:3.65}
  }
 };

 const BREAST=[{min:1,max:4,p:4.50},{min:5,max:9,p:3.95},{min:10,max:24,p:3.50},{min:25,max:49,p:2.95},{min:50,max:99999,p:2.50}];
 const BACK=[{min:1,max:4,p:4.95},{min:5,max:9,p:4.50},{min:10,max:24,p:4.25},{min:25,max:49,p:3.75},{min:50,max:99999,p:3.50}];
 const SLEEVE=[{min:1,max:4,p:3.50},{min:5,max:9,p:3.25},{min:10,max:24,p:2.95},{min:25,max:49,p:2.50},{min:50,max:99999,p:2.25}];
 const EMB=[{min:6,max:9,p:5.50},{min:10,max:24,p:4.95},{min:25,max:49,p:4.25},{min:50,max:99999,p:3.75}];

 const SERVICES={
  breastPrint:'left-breast-print',
  backPrint:'large-back-print',
  sleevePrint:'sleeve-print',
  breastEmb:'left-breast-embroidery',
  sleeveEmb:'sleeve-embroidery',
  embSetup:'embroidery-setup-1',
  fast:'fast-production',
  express:'express-production'
 };
 const serviceProducts={};

 const HEX={
  Black:'#111111',Navy:'#17233b','French Navy':'#17233b','Royal Blue':'#2459c4',
  'Light Grey':'#d5d5d5',White:'#fafafa',Charcoal:'#4a4a4a',Red:'#c8333b',
  'Classic Red':'#c8333b','Bottle Green':'#214d35','Dark Green':'#214d35',
  'Azure Blue':'#247dc2',Titanium:'#74787b',Yellow:'#e8ef1e','Hi Vis Yellow':'#e8ef1e',
  'Hi-Vis Yellow':'#e8ef1e',Orange:'#f47b20','Hi Vis Orange':'#f47b20'
 };
 const canonicalColour=c=>{
   const s=String(c||'').trim();
   if(/bottle\s*green/i.test(s)||/^dark\s*green$/i.test(s)) return 'Bottle Green';
   if(/^navy$/i.test(s)||/^french\s*navy$/i.test(s)) return s;
   return s;
 };
 const rate=(table,n)=>{const x=table.find(t=>n>=t.min&&n<=t.max);return x?x.p:0};
 const savingPct=(table,n)=>{
   if(!n)return 0;
   const base=table[0].p,current=rate(table,n);
   return current&&current<base?Math.round((1-current/base)*100):0;
 };
 const priceWithSaving=(prefix,price,pct)=>{
   const save=pct>0?` · SAVE ${pct}%`:'';
   return `${prefix}${money(price)} EACH + VAT${save}`;
 };
 const blankSizes=()=>({});
 const state={
  category:'tshirts',tier:'standard',material:'everyday',colour:null,sizes:blankSizes(),
  method:'print',back:false,sleeve:false,sleeveSide:'Left',sleeveMethod:'print',
  accreditation:'Gas Safe',embSetup:'new',service:'standard',editing:null
 };
 let products={},order=[],loading=false;
 let orderEmbSetup=null; // 'new' or 'existing' for the whole order
 let activeKit=null,kitTarget=null;
 // OPTIONAL REAL CUSTOMER WORK GALLERY.
 // Paste Shopify CDN image URLs below when ready. Leave src blank to hide a card.
 const CUSTOMER_WORK=[
   {src:'https://cdn.shopify.com/s/files/1/1725/3799/files/SKS-Img.png?v=1789934367',title:'SKS Complete Construction Partner',type:'High Vis Workwear'},
   {src:'https://cdn.shopify.com/s/files/1/1725/3799/files/RDH-Embroidery.png?v=1790074693',title:'RDH Property Services',type:'Embroidered Workwear'},
   {src:'https://cdn.shopify.com/s/files/1/1725/3799/files/TL-Joinery-Print.png?v=1790074693',title:'T.L Joinery and Construction',type:'Printed Workwear'}
 ];


 const KITS={
  'sole-trader':{
    title:'SOLE TRADER KIT',
    copy:'A simple branded setup for looking professional every day without over-ordering.',
    items:[
      {category:'tshirts',qty:5,label:'T-Shirts'},
      {category:'polos',qty:1,label:'Polo'},
      {category:'hoodies',qty:1,label:'Hoodie'},
      {category:'hivis',qty:1,label:'Hi-Vis'}
    ]
  },
  professional:{
    title:'PROFESSIONAL KIT',
    copy:'Our recommended all-round setup for a professional trade business.',
    items:[
      {category:'tshirts',qty:5,label:'T-Shirts'},
      {category:'polos',qty:2,label:'Polos'},
      {category:'hoodies',qty:2,label:'Hoodies'},
      {category:'softshells',qty:1,label:'Softshell'},
      {category:'hivis',qty:1,label:'Hi-Vis'}
    ]
  },
  team:{
    title:'TEAM KIT',
    copy:'A stronger setup for growing teams that need consistent branded workwear across the week.',
    items:[
      {category:'tshirts',qty:15,label:'T-Shirts'},
      {category:'polos',qty:6,label:'Polos'},
      {category:'hoodies',qty:6,label:'Hoodies'},
      {category:'softshells',qty:3,label:'Softshells'},
      {category:'hivis',qty:3,label:'Hi-Vis'}
    ]
  }
 };

 function productKey(){
  if(state.category==='tshirts'&&state.material==='cool')return'tshirts:cool';
  return state.category+':'+state.tier;
 }
 function productConfig(){
  const c=CATALOG[state.category];
  return state.category==='tshirts'&&state.material==='cool'?c.cool:c[state.tier];
 }
 function currentProduct(){return products[productKey()]||null}
 function qty(s=state){return Object.values(s.sizes||{}).reduce((a,b)=>a+(+b||0),0)}
 function normalise(v){return String(v||'').trim().toLowerCase()}
 function optionIndex(p,needle){
  const opts=(p&&p.options)||[];
  let i=opts.findIndex(o=>normalise(typeof o==='string'?o:o.name).includes(needle));
  return i<0?null:i;
 }
 function variantValue(v,i){return i===null?null:(v.options||[])[i]}
 function actualColourFor(p,displayColour){
  if(!p)return displayColour;
  const i=optionIndex(p,'colour') ?? optionIndex(p,'color');
  if(i===null)return displayColour;
  const actual=[...new Set(p.variants.map(v=>variantValue(v,i)).filter(Boolean))];
  return actual.find(c=>canonicalColour(c)===displayColour)||displayColour;
 }
 function coloursFor(p){
  if(!p)return[];
  const i=optionIndex(p,'colour') ?? optionIndex(p,'color');
  if(i===null)return['Default'];
  return [...new Set(p.variants.map(v=>canonicalColour(variantValue(v,i))).filter(Boolean))];
 }
 function sizesFor(p,colour){
  if(!p)return[];
  const ci=optionIndex(p,'colour') ?? optionIndex(p,'color'), si=optionIndex(p,'size');
  if(si===null)return[];
  const actual=actualColourFor(p,colour);
  return [...new Set(p.variants.filter(v=>ci===null||variantValue(v,ci)===actual).map(v=>variantValue(v,si)).filter(Boolean))];
 }
 function variantFor(p,colour,size){
  if(!p)return null;
  const ci=optionIndex(p,'colour') ?? optionIndex(p,'color'), si=optionIndex(p,'size');
  const actual=actualColourFor(p,colour);
  return p.variants.find(v=>(ci===null||variantValue(v,ci)===actual)&&(si===null||variantValue(v,si)===size))||null;
 }
 // PRODUCT GALLERY — DISPLAY ONLY. Never changes builder/order data.
 // V1 gallery: Product / Your Branding / Get Seen.
 const BRANDING_CLOSEUP='https://cdn.shopify.com/s/files/1/1725/3799/files/Print-Embroidery.png?v=1789833642';
 const BACK_BRANDING='https://cdn.shopify.com/s/files/1/1725/3799/files/Large-Back-Print.png?v=1789834581';
 // DEFAULT PRODUCT HERO — shown before the customer actively chooses a colour.
 // Paste one dedicated hero image URL per actual Shopify product here.
 const PRODUCT_HEROES={
  'standard-workwear-t-shirt':'','premium-workwear-t-shirt':'','cool-performance-workwear-t-shirt':'',
  'standard-workwear-polo':'','premium-workwear-polo':'','standard-workwear-hoodie':'','premium-workwear-hoodie':'',
  'standard-workwear-sweatshirt':'','premium-workwear-sweatshirt':'','standard-workwear-softshell':'','premium-workwear-softshell':'','standard-high-vis-vest':''
 };
 let colourActivelySelected=false,activeTrade='';
 let premiumGalleryIndex=0;
 function imageUrl(img){if(!img)return'';if(typeof img==='string')return img;return img.src||img.url||''}
 function defaultProductHero(){
  const p=currentProduct(),cfg=productConfig();if(!p)return'';
  return (PRODUCT_HEROES[(cfg||{}).handle]||'')||imageUrl(p.featured_image)||imageUrl((p.images||[])[0]);
 }
 function selectedColourHero(){
  const p=currentProduct();if(!p)return'';
  const ci=optionIndex(p,'colour') ?? optionIndex(p,'color'),actual=actualColourFor(p,state.colour);
  const v=(p.variants||[]).find(x=>ci===null||variantValue(x,ci)===actual)||(p.variants||[])[0];
  return imageUrl(v&&(v.featured_image||v.image))||defaultProductHero();
 }
 function premiumGallery(){
  return [
   {src:colourActivelySelected?selectedColourHero():defaultProductHero(),label:colourActivelySelected?'SELECTED COLOUR':'PRODUCT'},
   {src:BRANDING_CLOSEUP,label:'YOUR BRANDING'},
   {src:BACK_BRANDING,label:'GET SEEN'}
  ];
 }
 function renderPreviewImage(){
  const art=$('#pcwb-shirt-art'),main=art&&art.closest('.pcwb-product-main');if(!art)return;
  const g=premiumGallery();if(premiumGalleryIndex>=g.length)premiumGalleryIndex=0;
  const item=g[premiumGalleryIndex]||g[0],logo=art.querySelector('span');
  if(item&&item.src){
   art.style.backgroundImage=`url("${String(item.src).replace(/"/g,'%22')}")`;art.style.backgroundColor='transparent';
   art.style.backgroundPosition='center';art.style.backgroundRepeat='no-repeat';art.style.backgroundSize='contain';art.style.clipPath='none';
   art.removeAttribute('data-gallery-label');if(main)main.classList.remove('is-placeholder');if(logo)logo.style.display='none';
  }else{
   art.style.backgroundImage='none';art.style.backgroundColor='#edf2f0';art.style.clipPath='none';
   art.dataset.galleryLabel=((item&&item.label)||'PRODUCT IMAGE')+' PLACEHOLDER';if(main)main.classList.add('is-placeholder');if(logo)logo.style.display='none';
  }
 }
 function renderProductThumbs(){
  const box=$('#pcwb-product-thumbs');if(!box)return;const g=premiumGallery();
  box.innerHTML=g.map((item,i)=>item.src
   ? `<button type="button" class="pcwb-product-thumb ${i===premiumGalleryIndex?'active':''}" data-premium-gallery="${i}" style="background-image:url('${String(item.src).replace(/'/g,"%27")}')" aria-label="${item.label}"></button>`
   : `<button type="button" class="pcwb-product-thumb pcwb-gallery-placeholder ${i===premiumGalleryIndex?'active':''}" data-premium-gallery="${i}" data-label="${item.label}" aria-label="${item.label} placeholder"></button>`
  ).join('');
  $$('[data-premium-gallery]',box).forEach(btn=>btn.onclick=()=>{premiumGalleryIndex=+btn.dataset.premiumGallery;renderPreviewImage();renderProductThumbs()});
 }
 function renderCustomerWork(){
  const sec=$('#pcwb-real-work'),grid=$('#pcwb-real-work-grid');
  if(!sec||!grid)return;
  sec.hidden=false;
  sec.style.display='block';
  const cards=(CUSTOMER_WORK&&CUSTOMER_WORK.length?CUSTOMER_WORK:[
   {src:'',title:'Customer work',type:'Branded workwear'},
   {src:'',title:'Customer work',type:'Branded workwear'},
   {src:'',title:'Customer work',type:'Branded workwear'}
  ]).slice(0,3);
  grid.innerHTML=cards.map((x,i)=>{
   if(x.src){
    return `<div class="pcwb-real-work-card"><img src="${x.src}" alt="${x.title||'Print Chimp customer workwear'}" loading="lazy"><b>${x.title||'Customer work'}</b><span>${x.type||'Branded workwear'}</span></div>`;
   }
   return `<div class="pcwb-real-work-card"><div class="pcwb-real-work-placeholder">REAL CUSTOMER<br>PHOTO ${i+1}</div><b>Customer transformation</b><span>Real Print Chimp workwear</span></div>`;
  }).join('');
 }
 function swatch(c){return HEX[c]||'#7d8582'}
 function sizeShort(s){
  const m={'Small':'S','Medium':'M','Large':'L','Extra Large':'XL','X-Large':'XL','XXL':'2XL','XXXL':'3XL'};
  return m[s]||s;
 }

 function decorationPools(draft=true){
  const lines=order.map((x,i)=>({...x,_i:i}));
  if(draft&&qty(state))lines.push({...state,qty:qty(state),_draft:true});
  const p={breastPrint:0,breastEmb:0,back:0,sleevePrint:0,sleeveEmb:0};
  lines.forEach(x=>{
   const n=x.qty||qty(x);
   if(x.method==='embroidery')p.breastEmb+=n;else p.breastPrint+=n;
   if(x.back)p.back+=n;
   if(x.sleeve){if(x.sleeveMethod==='embroidery')p.sleeveEmb+=n;else p.sleevePrint+=n}
  });
  return p;
 }
 function lineTotal(line,pools){
  const n=line.qty||qty(line), pc=CATALOG[line.category];
  const base=(line.category==='tshirts'&&line.material==='cool'?pc.cool:pc[line.tier]).base;
  const breast=line.method==='embroidery'?rate(EMB,pools.breastEmb):rate(BREAST,pools.breastPrint);
  const back=line.back?rate(BACK,pools.back):0;
  const sleeve=line.sleeve?(line.sleeveMethod==='embroidery'?rate(EMB,pools.sleeveEmb):rate(SLEEVE,pools.sleevePrint)):0;
  return n*(base+breast+back+sleeve);
 }
 function embroiderySetupTotal(lines){
  const hasEmb=lines.some(x=>x.method==='embroidery'||(x.sleeve&&x.sleeveMethod==='embroidery'));
  if(!hasEmb)return 0;
  const choice=orderEmbSetup || lines.find(x=>x.embSetup)?.embSetup || state.embSetup;
  return choice==='new'?12.50:0;
 }
 function orderTotals(includeDraft=false){
  const lines=order.slice();
  if(includeDraft&&qty(state))lines.push({...state,qty:qty(state)});
  const pools=decorationPools(includeDraft);
  let total=lines.reduce((a,x)=>a+lineTotal(x,pools),0)+embroiderySetupTotal(lines);
  return {lines,pools,total};
 }
 function currentTotal(){
  if(!qty(state))return 0;
  const lines=order.slice();
  if(state.editing!==null)lines.splice(state.editing,1);
  lines.push({...state,qty:qty(state)});
  const pools={breastPrint:0,breastEmb:0,back:0,sleevePrint:0,sleeveEmb:0};
  lines.forEach(x=>{const n=x.qty||qty(x);if(x.method==='embroidery')pools.breastEmb+=n;else pools.breastPrint+=n;if(x.back)pools.back+=n;if(x.sleeve){if(x.sleeveMethod==='embroidery')pools.sleeveEmb+=n;else pools.sleevePrint+=n}});
  return lineTotal({...state,qty:qty(state)},pools)+(embroiderySetupTotal(lines)&&state.embSetup==='new'&&lines.filter(x=>x.embSetup==='new').length===1?12.50:0);
 }
 function currentPools(){
  const lines=order.slice(); if(state.editing!==null)lines.splice(state.editing,1);
  if(qty(state))lines.push({...state,qty:qty(state)});
  const p={breastPrint:0,breastEmb:0,back:0,sleevePrint:0,sleeveEmb:0};
  lines.forEach(x=>{const n=x.qty||qty(x);if(x.method==='embroidery')p.breastEmb+=n;else p.breastPrint+=n;if(x.back)p.back+=n;if(x.sleeve){if(x.sleeveMethod==='embroidery')p.sleeveEmb+=n;else p.sleevePrint+=n}});
  return p;
 }
 function existingPools(){
  const lines=order.slice(); if(state.editing!==null)lines.splice(state.editing,1);
  const p={breastPrint:0,breastEmb:0,back:0,sleevePrint:0,sleeveEmb:0};
  lines.forEach(x=>{
    const n=x.qty||qty(x);
    if(x.method==='embroidery')p.breastEmb+=n;else p.breastPrint+=n;
    if(x.back)p.back+=n;
    if(x.sleeve){if(x.sleeveMethod==='embroidery')p.sleeveEmb+=n;else p.sleevePrint+=n}
  });
  return p;
 }

 async function ensureProduct(){
  const key=productKey(),cfg=productConfig(); if(products[key]||!cfg)return;
  loading=true;R.classList.add('pcwb-loading');
  try{
   const r=await fetch('/products/'+cfg.handle+'.js?pcwb='+Date.now(),{cache:'no-store'}); if(!r.ok)throw new Error(cfg.handle);
   products[key]=await r.json();
  }catch(e){console.warn('Print Chimp Workwear Builder: could not load',cfg.handle,e)}
  loading=false;R.classList.remove('pcwb-loading');
 }
 function resetSizes(){state.sizes={}}
 async function setProductChoice(){
  premiumGalleryIndex=0;
  await ensureProduct();
  const p=currentProduct(),cols=coloursFor(p);
  if(!cols.includes(state.colour))state.colour=cols[0]||'Black';
  const valid=sizesFor(p,state.colour),next={};
  valid.forEach(s=>next[s]=state.sizes[s]||0); state.sizes=next;
  renderDynamicOptions();render();
 }
 function renderDynamicOptions(){
  const p=currentProduct(),cols=coloursFor(p),sizes=sizesFor(p,state.colour);
  $('#pcwb-colours').innerHTML=cols.map(c=>`<button class="pcwb-colour ${c===state.colour?'active':''}" data-colour="${String(c).replace(/"/g,'&quot;')}" style="--sw:${swatch(c)}" title="${c}" aria-label="${c}"></button>`).join('');
  $('#pcwb-size-grid').innerHTML=sizes.map(s=>`<div class="pcwb-size-row" data-size="${String(s).replace(/"/g,'&quot;')}"><b>${sizeShort(s)}</b><button type="button" data-dir="-1" aria-label="Decrease quantity"></button><input class="pcwb-size-input" value="${state.sizes[s]||0}" readonly><button type="button" data-dir="1" aria-label="Increase quantity">+</button></div>`).join('');
  bindDynamic();
 }
 function bindDynamic(){
  $$('.pcwb-colour').forEach(x=>x.onclick=()=>{state.colour=x.dataset.colour;colourActivelySelected=true;premiumGalleryIndex=0;resetSizes();setProductChoice()});
  $$('.pcwb-size-row button').forEach(b=>b.onclick=()=>{const row=b.closest('.pcwb-size-row'),s=row.dataset.size,d=+b.dataset.dir;state.sizes[s]=Math.max(0,(state.sizes[s]||0)+d);$('.pcwb-size-input',row).value=state.sizes[s];render()});
 }

 function kitOrderedQty(category){
  return order.filter(x=>x.category===category).reduce((a,x)=>a+(+x.qty||0),0);
 }
 function renderKit(){
  const sec=$('#pcwb-kit'),grid=$('#pcwb-kit-grid'),target=$('#pcwb-kit-target');
  if(!activeKit||!KITS[activeKit]){
    if(sec)sec.hidden=true;
    if(target)target.hidden=true;
    return;
  }
  const kit=KITS[activeKit];
  sec.hidden=false;
  $('#pcwb-kit-title').textContent=kit.title;
  $('#pcwb-kit-copy').textContent=kit.copy;
  grid.innerHTML=kit.items.map(item=>{
    const have=kitOrderedQty(item.category);
    const done=have>=item.qty;
    const remaining=Math.max(0,item.qty-have);
    return `<button class="pcwb-kit-item ${done?'done':''} ${kitTarget&&kitTarget.category===item.category?'active':''}" data-kit-category="${item.category}" data-kit-qty="${item.qty}">
      <strong>${item.label.toUpperCase()}</strong>
      <span>${item.qty}</span>
      <small>${done?'✓ Recommended quantity added':have?`${have} added · ${remaining} still recommended`:'CHOOSE YOUR SIZES →'}</small>
    </button>`;
  }).join('');
  $$('[data-kit-category]',grid).forEach(btn=>btn.onclick=async()=>{
    kitTarget={category:btn.dataset.kitCategory,qty:+btn.dataset.kitQty};
    await setCategory(kitTarget.category,true);
    renderKit();
    render();
  });
  if(kitTarget&&state.category===kitTarget.category){
    const have=kitOrderedQty(kitTarget.category);
    const remaining=Math.max(0,kitTarget.qty-have);
    target.hidden=false;
    target.textContent=remaining
      ? `KIT TARGET: ADD ${remaining} MORE ${CATALOG[kitTarget.category].label.toUpperCase()} — split them across the sizes you need.`
      : `KIT TARGET REACHED: ${kitTarget.qty} ${CATALOG[kitTarget.category].label.toUpperCase()} ADDED ✓`;
  }else target.hidden=true;
 }
 const HERO_BASE='https://cdn.shopify.com/s/files/1/1725/3799/files/';
 const TRADE_HEROES={
  plumber:['Plumbers-Workwear.png?v=1789829731','PLUMBERS & HEATING ENGINEERS'],plumbing:['Plumbers-Workwear.png?v=1789829731','PLUMBERS & HEATING ENGINEERS'],heating:['Plumbers-Workwear.png?v=1789829731','PLUMBERS & HEATING ENGINEERS'],'heating-engineer':['Plumbers-Workwear.png?v=1789829731','PLUMBERS & HEATING ENGINEERS'],
  electrician:['Electricians-Workwear.png?v=1789829731','ELECTRICIANS'],electrical:['Electricians-Workwear.png?v=1789829731','ELECTRICIANS'],
  builder:['BuildingConstruction-Workwear.png?v=1789831571','BUILDERS & CONSTRUCTION'],builders:['BuildingConstruction-Workwear.png?v=1789831571','BUILDERS & CONSTRUCTION'],construction:['BuildingConstruction-Workwear.png?v=1789831571','BUILDERS & CONSTRUCTION'],
  'painter-decorator':['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],painter:['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],painting:['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],'painting-decorating':['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],decorator:['Painters-Workwear.png?v=1789831570','PAINTERS & DECORATORS'],
  landscaper:['Landscapers-Workwear.png?v=1789831570','LANDSCAPERS'],landscaping:['Landscapers-Workwear.png?v=1789831570','LANDSCAPERS'],
  roofer:['Roofers-Workwear.png?v=1789831570','ROOFERS'],roofing:['Roofers-Workwear.png?v=1789831570','ROOFERS'],
  joiner:['Joinery-Workwear.png?v=1789831570','JOINERS & CARPENTERS'],joinery:['Joinery-Workwear.png?v=1789831570','JOINERS & CARPENTERS'],carpenter:['Joinery-Workwear.png?v=1789831570','JOINERS & CARPENTERS'],carpentry:['Joinery-Workwear.png?v=1789831570','JOINERS & CARPENTERS'],
    flooring:['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],'floor-fitter':['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],'floor-fitters':['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],floorer:['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],floorers:['Floorers-Workwear.png?v=1790080200','FLOOR FITTERS'],
  hvac:['Hvac-Workwear.png?v=1789831570','HVAC & AIR CONDITIONING'],'air-conditioning':['Hvac-Workwear.png?v=1789831570','HVAC & AIR CONDITIONING'],'air-con':['Hvac-Workwear.png?v=1789831570','HVAC & AIR CONDITIONING']
 };
 function tradePersonalise(trade){
  activeTrade=String(trade||'').trim().toLowerCase();
  const c=TRADE_HEROES[activeTrade],h=$('#pcwb-hero-image'),p=$('.pcwb-hero-placeholder'),k=$('.pcwb-kicker');
  if(h){h.src=HERO_BASE+(c?c[0]:'Workwear-Builder.png?v=1789831570');h.style.display='block';if(p)p.style.display='none'}
  if(k)k.textContent=c?'CUSTOM WORKWEAR FOR '+c[1]:'CUSTOM WORKWEAR FOR BUSINESSES';
 }
 function setCategory(key,scroll=true){
  if(!CATALOG[key])key='tshirts';
  state.category=key;state.material='everyday';state.tier='standard';state.colour=null;state.sizes={};state.editing=null;colourActivelySelected=false;premiumGalleryIndex=0;
  if(key==='hivis'){
    state.sleeve=false;
    state.sleeveMethod='print';
    const sleeveCheck=$('#pcwb-sleeve');
    if(sleeveCheck)sleeveCheck.checked=false;
  }
  const c=CATALOG[key];
  $('#pcwb-config-eyebrow').textContent=c.eyebrow;$('#pcwb-config-title').textContent=c.title;$('#pcwb-config-copy').textContent=c.copy;
  const typeStep=$('#pcwb-type-step');
  typeStep.textContent=key==='tshirts'?'1. CHOOSE YOUR T-SHIRT':'';
  typeStep.style.display=key==='tshirts'?'block':'none';

  $('#pcwb-material-grid').hidden=key!=='tshirts';
  $('#pcwb-quality-wrap').hidden=key==='hivis';
  $('#pcwb-quality-step').textContent=key==='tshirts'?'2. CHOOSE YOUR QUALITY':'1. CHOOSE YOUR QUALITY';

  $$('.pcwb-tier-card[data-tier="premium"]').forEach(x=>x.hidden=key==='hivis');

  if(key==='hivis'){
    typeStep.style.display='none';
    typeStep.textContent='';
    $('#pcwb-colour-step').textContent='1. CHOOSE YOUR COLOUR';
    $('#pcwb-size-step').textContent='2. ADD YOUR SIZES & QUANTITIES';
  }else{
    $('#pcwb-colour-step').textContent=(key==='tshirts'?'3.':'2.')+' CHOOSE YOUR COLOUR';
    $('#pcwb-size-step').textContent=(key==='tshirts'?'4.':'3.')+' ADD YOUR SIZES & QUANTITIES';
  }
  $('#pcwb-add-label').textContent='YOUR '+c.label.toUpperCase();
  $('#pcwb-size-guide-title').textContent=c.label.toUpperCase()+' SIZE GUIDE';
  const sleeveBox=$('#pcwb-sleeve')?.closest('.pcwb-sleeve-row');
  if(sleeveBox)sleeveBox.hidden=key==='hivis';
  $$('.pcwb-garment').forEach(x=>x.classList.toggle('active',x.dataset.start===key));
  setProductChoice();
  if(scroll)$('#pcwb-configurator').scrollIntoView({behavior:'smooth',block:'start'});
 }
 function unitAt(n){
  const cfg=productConfig(); if(!cfg)return 0;
  if((state.method==='embroidery'||(state.sleeve&&state.sleeveMethod==='embroidery'))&&n<6)return null;
  return cfg.base+(state.method==='embroidery'?rate(EMB,n):rate(BREAST,n))+(state.back?rate(BACK,n):0)+(state.sleeve?(state.sleeveMethod==='embroidery'?rate(EMB,n):rate(SLEEVE,n)):0);
 }
 function nextMsg(n){
  if(!n)return'Add garments to see your branding price';
  const targets=state.method==='embroidery'?[6,10,25,50]:[5,10,25,50];
  const target=targets.find(t=>t>n);
  if(!target)return'Best branding rate unlocked';
  if(state.method==='embroidery'&&n<6)
    return`Add ${target-n} more embroidered garment${target-n===1?'':'s'} to reach the 6 garment minimum`;
  return`Add ${target-n} more branded garment${target-n===1?'':'s'} → unlock lower branding prices`;
 }

 function syncStepHeadings(){
  const typeStep=$('#pcwb-type-step');
  if(!typeStep)return;

  if(state.category==='tshirts'){
    typeStep.style.display='block';
    typeStep.textContent='1. CHOOSE YOUR T-SHIRT';
    $('#pcwb-quality-step').textContent='2. CHOOSE YOUR QUALITY';
  }else if(state.category==='hivis'){
    typeStep.style.display='none';
    typeStep.textContent='';
  }else{
    typeStep.style.display='none';
    typeStep.textContent='';
    $('#pcwb-quality-step').textContent='1. CHOOSE YOUR QUALITY';
  }
}

function render(){
  const c=CATALOG[state.category],n=qty(state),pools=currentPools(),cfg=productConfig();

  // Keep every control visually synced with state. This is especially important
  // when reopening an existing order line with EDIT.
  const backBox=$('#pcwb-back'); if(backBox)backBox.checked=!!state.back;
  const sleeveBoxCheck=$('#pcwb-sleeve'); if(sleeveBoxCheck)sleeveBoxCheck.checked=!!state.sleeve;

  $$('input[name="pcwb-method"]').forEach(x=>{
    x.checked=x.value===state.method;
    const label=x.closest('label');
    if(label)label.classList.toggle('active',x.checked);
  });
  if(orderEmbSetup)state.embSetup=orderEmbSetup;
  $$('input[name="pcwb-emb-setup"]').forEach(x=>{
    x.checked=x.value===state.embSetup;
    x.disabled=false;
    const label=x.closest('label');
    if(label)label.classList.toggle('active',x.checked);
  });

  const embExisting=$('#pcwb-embroidery-existing');
  if(embExisting){
    let status=embExisting.querySelector('.pcwb-order-emb-status');
    const normalChildren=[...embExisting.children].filter(el=>!el.classList.contains('pcwb-order-emb-status'));
    if(orderEmbSetup && state.editing===null){
      normalChildren.forEach(el=>el.style.display='none');
      if(!status){
        status=document.createElement('div');
        status.className='pcwb-order-emb-status';
        status.style.cssText='padding:16px 18px;border:2px solid #08B275;border-radius:12px;background:#f3fff9;';
        embExisting.appendChild(status);
      }
      status.style.display='block';
      status.innerHTML=orderEmbSetup==='new'
        ? `<strong style="display:block;font-size:15px;font-weight:900;color:#111;">ONE SETUP COVERS YOUR WHOLE ORDER ✓</strong><span style="display:block;margin-top:6px;font-size:13px;line-height:1.45;color:#333;">New embroidery logo — £15 inc VAT one-time setup. Add embroidery to any other garments without another setup charge.</span>`
        : `<strong style="display:block;font-size:15px;font-weight:900;color:#111;">YOUR EMBROIDERY LOGO IS ALREADY ON FILE ✓</strong><span style="display:block;margin-top:6px;font-size:13px;line-height:1.45;color:#333;">No setup charge. Add embroidery to any other garments in this order.</span>`;
    }else{
      normalChildren.forEach(el=>el.style.display='');
      if(status)status.style.display='none';
    }
  }
  $$('input[name="pcwb-sleeve-side"]').forEach(x=>{
    x.checked=x.value===state.sleeveSide;
    const label=x.closest('label');
    if(label)label.classList.toggle('active',x.checked);
  });
  $$('input[name="pcwb-sleeve-method"]').forEach(x=>{
    x.checked=x.value===state.sleeveMethod;
    const label=x.closest('label');
    if(label)label.classList.toggle('active',x.checked);
  });

  const accred=$('#pcwb-accreditation');
  if(accred && [...accred.options].some(o=>o.value===state.accreditation)) accred.value=state.accreditation;

  $('#pcwb-total-qty').textContent=n;$('#pcwb-add-qty').textContent=n;$('#pcwb-add-total').textContent=money(currentTotal());
  $('#pcwb-colour-name').textContent=state.colour||'—';$('#pcwb-preview-colour').textContent=state.colour||'—';
  const quality=state.category==='tshirts'&&state.material==='cool'?'Cool Performance':state.tier==='premium'?'Premium':'Standard';
  $('#pcwb-preview-name').textContent=quality+' '+c.singular;
  renderPreviewImage();
  renderProductThumbs();
  renderCustomerWork();
  $('#pcwb-next-tier').textContent=nextMsg(state.method==='embroidery'?pools.breastEmb:pools.breastPrint);
  $$('.pcwb-material-card').forEach(x=>x.classList.toggle('active',x.dataset.material===state.material));
  $$('.pcwb-tier-card').forEach(x=>x.classList.toggle('active',x.dataset.tier===state.tier));
  $('#pcwb-material-grid').hidden=state.category!=='tshirts';
  $('#pcwb-cool-note').hidden=!(state.category==='tshirts'&&state.material==='cool');
  if(state.category==='tshirts'){
    $('#pcwb-quality-wrap').hidden=state.material==='cool';
    $('#pcwb-quality-step').textContent='2. CHOOSE YOUR QUALITY';
  }else{
    $('#pcwb-quality-wrap').hidden=state.category==='hivis';
    $('#pcwb-quality-step').textContent='1. CHOOSE YOUR QUALITY';
  }

  // Correct "from branded" prices: base + 50+ left breast print.
  $('#pcwb-standard-from').textContent=money((CATALOG[state.category].standard||{base:0}).base+2.50);
  const prem=CATALOG[state.category].premium;
  $('#pcwb-premium-from').textContent=prem?money(prem.base+2.50):'—';
  $('#pcwb-cool-from').textContent=money(CATALOG.tshirts.cool.base+2.50);

  const ns=[1,5,10,25,50],ids=['#pcwb-price-1','#pcwb-price-5','#pcwb-price-10','#pcwb-price-25','#pcwb-price-50'];
  ids.forEach((id,i)=>{const v=unitAt(ns[i]);$(id).textContent=v===null?'6+ ONLY':money(v)});
  const pooledBreast=state.method==='embroidery'?pools.breastEmb:pools.breastPrint;
  $$('.pcwb-price-ladder>div').forEach(x=>{const a=+x.dataset.min,b=+x.dataset.max;x.classList.toggle('active',pooledBreast>=a&&pooledBreast<=b)});
  $('#pcwb-pool-status').textContent='Mix & match your workwear — the more garments you brand, the less you pay per print.';
  const selected=[state.method==='embroidery'?'Left breast embroidery':'Left breast print'];
  if(state.back)selected.push('Large back print');
  if(state.sleeve)selected.push((state.accreditation||'Accreditation')+' sleeve '+state.sleeveMethod);
  const breastRateNow=state.method==='embroidery'?rate(EMB,pooledBreast):rate(BREAST,pooledBreast);
  const breastTable=state.method==='embroidery'?EMB:BREAST;
  const breastSave=savingPct(breastTable,pooledBreast);
  $('.pcwb-ladder-title span').textContent=pooledBreast
    ? `${state.method==='embroidery'?'LEFT BREAST EMBROIDERY':'LEFT BREAST PRINT'} · ${money(breastRateNow)} EACH + VAT${breastSave?` · SAVE ${breastSave}%`:''}`
    : selected.join(' + ');

  // Preview optional upgrade pricing BEFORE the customer clicks it.
  // Existing matching applications + every garment currently being configured.
  const existing=existingPools();
  const previewBackQty=existing.back+n;
  const existingSleeve=state.sleeveMethod==='embroidery'?existing.sleeveEmb:existing.sleevePrint;
  const previewSleeveQty=existingSleeve+n;

  if(n){
    const br=rate(BACK,previewBackQty);
    const backSave=savingPct(BACK,previewBackQty);
    $('#pcwb-back-rate').textContent=`+${money(br)} EACH + VAT${backSave?` · SAVE ${backSave}%`:''}`;

    const sleeveTable=state.sleeveMethod==='embroidery'?EMB:SLEEVE;
    const sr=rate(sleeveTable,previewSleeveQty);
    const sleeveSave=savingPct(sleeveTable,previewSleeveQty);
    $('#pcwb-sleeve-rate').textContent=`+${money(sr)} EACH + VAT${sleeveSave?` · SAVE ${sleeveSave}%`:''}`;
  }else{
    $('#pcwb-back-rate').textContent='ADD SIZES TO SEE YOUR PRICE';
    $('#pcwb-sleeve-rate').textContent='ADD SIZES TO SEE YOUR PRICE';
  }

  $('#pcwb-embroidery-panel').hidden=state.method!=='embroidery';
  $('#pcwb-embroidery-warning').style.display=(state.method==='embroidery'&&pools.breastEmb<6)?'block':'none';
  $('#pcwb-embroidery-existing').style.display=(state.method==='embroidery'&&pools.breastEmb>=6)?'block':'none';
  $('#pcwb-accreditation-panel').hidden=!state.sleeve;$('#pcwb-other-accred').hidden=state.accreditation!=='Other';
  $('#pcwb-sleeve-emb-warning').hidden=!(state.sleeve&&state.sleeveMethod==='embroidery'&&pools.sleeveEmb<6);

  const invalid=!n||(state.method==='embroidery'&&pools.breastEmb<6)||(state.sleeve&&state.sleeveMethod==='embroidery'&&pools.sleeveEmb<6);
  $('#pcwb-add-order').disabled=invalid;$('#pcwb-add-order').classList.toggle('disabled',invalid);
  $('#pcwb-add-order').textContent=state.editing===null?'ADD TO ORDER →':'UPDATE GARMENT →';
  renderOrder();renderService();renderKit();
 }

 function renderOrder(){
  const sec=$('#pcwb-order'),box=$('#pcwb-order-items');
  if(!order.length){sec.hidden=true;box.innerHTML='';return}
  sec.hidden=false;
  const pools=decorationPools(false);
  const poolBits=[];
  if(pools.breastPrint)poolBits.push(`${pools.breastPrint} left-breast prints`);
  if(pools.breastEmb)poolBits.push(`${pools.breastEmb} left-breast embroideries`);
  if(pools.back)poolBits.push(`${pools.back} back prints`);
  if(pools.sleevePrint)poolBits.push(`${pools.sleevePrint} sleeve prints`);
  if(pools.sleeveEmb)poolBits.push(`${pools.sleeveEmb} sleeve embroideries`);
  box.innerHTML=`<div class="pcwb-pooling-note">✓ WE COUNT THE SAME BRANDING ACROSS YOUR WHOLE ORDER TO GIVE YOU THE BEST PRICE: ${poolBits.join(' · ')}</div>`+
   order.map((x,i)=>{
    const ss=Object.entries(x.sizes).filter(v=>v[1]).map(([s,q])=>`${sizeShort(s)}×${q}`).join(' · ');
    const br=[x.method==='embroidery'?'Left breast embroidery':'Left breast print'];if(x.back)br.push('Back print');if(x.sleeve)br.push(`${x.accreditation} · ${x.sleeveSide} sleeve · ${x.sleeveMethod}`);
    const quality=x.category==='tshirts'&&x.material==='cool'?'Cool Performance':x.tier==='premium'?'Premium':'Standard';
    return `<div class="pcwb-order-item"><div><b>${x.qty} × ${quality} ${CATALOG[x.category].label}</b><span>${x.colour} · ${ss} · ${br.join(' · ')}</span></div><strong>${money(lineTotal(x,pools))} + VAT</strong><div class="pcwb-order-actions"><button data-edit="${i}">EDIT</button><button class="pcwb-remove" data-remove="${i}">REMOVE</button></div></div>`
   }).join('');
  $$('[data-edit]',box).forEach(b=>b.onclick=()=>editLine(+b.dataset.edit));
  $$('[data-remove]',box).forEach(b=>b.onclick=()=>{
    order.splice(+b.dataset.remove,1);
    if(!order.some(x=>x.method==='embroidery'||(x.sleeve&&x.sleeveMethod==='embroidery'))){
      orderEmbSetup=null;
      state.embSetup='new';
    }
    render();
  });
 }
 async function editLine(i){
  const x=order[i]; if(!x)return;
  Object.assign(state,{...x,sizes:{...x.sizes},editing:i});
  colourActivelySelected=true;premiumGalleryIndex=0;
  if(!state.method)state.method='print';
  if(!state.sleeveMethod)state.sleeveMethod='print';
  if(state.category==='hivis'){state.sleeve=false;state.sleeveMethod='print'}
  const sleeveBox=$('#pcwb-sleeve')?.closest('.pcwb-sleeve-row');
  if(sleeveBox)sleeveBox.hidden=state.category==='hivis';
  await ensureProduct();renderDynamicOptions();render();
  $('#pcwb-configurator').scrollIntoView({behavior:'smooth',block:'start'});
 }
 function renderService(){
  const totals=orderTotals(false),base=totals.total;

  // Embroidery anywhere in the saved order OR current configurator means Standard only.
  const savedEmbroidery=order.some(x=>x.method==='embroidery'||(x.sleeve&&x.sleeveMethod==='embroidery'));
  const draftEmbroidery=qty(state)>0 && (state.method==='embroidery'||(state.sleeve&&state.sleeveMethod==='embroidery'));
  const hasEmbroidery=savedEmbroidery||draftEmbroidery;

  const standard=$('input[name="pcwb-service"][value="standard"]');
  const fast=$('input[name="pcwb-service"][value="fast"]');
  const express=$('input[name="pcwb-service"][value="express"]');

  [fast,express].forEach(x=>{
    if(!x)return;
    x.disabled=hasEmbroidery;
    const card=x.closest('label');
    if(card){
      card.style.display=hasEmbroidery?'none':'';
      card.style.opacity='';
      card.style.cursor='';
      card.classList.remove('active');
    }
  });

  if(standard){
    const card=standard.closest('label');
    if(card)card.style.display='';
  }

  if(hasEmbroidery){
    state.service='standard';
    if(standard)standard.checked=true;
    if(fast)fast.checked=false;
    if(express)express.checked=false;
  }

  let fee=0;
  let label=hasEmbroidery?'Standard service · Embroidery orders':'Standard service included';

  const garmentQty=order.reduce((sum,x)=>sum+(+x.qty||0),0);

  if(!hasEmbroidery&&state.service==='fast'){
    fee=garmentQty*2.99;
    label='Fast production · '+garmentQty+' garment'+(garmentQty===1?'':'s')+' · '+money(fee)+' + VAT';
  }
  if(!hasEmbroidery&&state.service==='express'){
    fee=garmentQty*4.99;
    label='Express production · '+garmentQty+' garment'+(garmentQty===1?'':'s')+' · '+money(fee)+' + VAT';
  }

  const checkoutEx=base+fee;
  const checkoutInc=checkoutEx*1.20;
  $('#pcwb-checkout-total').innerHTML=
    `<div style="display:flex;align-items:baseline;gap:10px;flex-wrap:nowrap;white-space:nowrap;font-weight:900;line-height:1.1"><span style="font-size:1.18em;color:#ffffff !important">${money(checkoutEx)}</span><span style="font-size:.78em;color:#ffffff !important">EX VAT</span></div>`+
    `<div style="display:flex;align-items:baseline;gap:10px;flex-wrap:nowrap;white-space:nowrap;margin-top:8px;font-weight:900;line-height:1.1"><span style="font-size:1.05em;color:#08B275 !important">${money(checkoutInc)}</span><span style="font-size:.82em;color:#08B275 !important">INC VAT</span></div>`;
  $('#pcwb-service-summary').textContent=label;
  $$('.pcwb-service-grid label').forEach(l=>{
    const input=l.querySelector('input');
    if(input)l.classList.toggle('active',input.value===state.service);
  });
  $('#pcwb-checkout').disabled=!order.length;
  $('#pcwb-checkout').classList.toggle('disabled',!order.length);
 }

 $$('.pcwb-material-card').forEach(x=>x.onclick=async()=>{state.material=x.dataset.material;colourActivelySelected=false;premiumGalleryIndex=0;resetSizes();await setProductChoice()});
 $$('.pcwb-tier-card').forEach(x=>x.onclick=async()=>{state.tier=x.dataset.tier;colourActivelySelected=false;premiumGalleryIndex=0;resetSizes();await setProductChoice()});
 $$('input[name="pcwb-method"]').forEach(x=>x.onchange=()=>{
   state.method=x.value;
   render();
 });
 $$('input[name="pcwb-emb-setup"]').forEach(x=>x.onchange=()=>{
   state.embSetup=x.value;
   if(!orderEmbSetup)orderEmbSetup=x.value;
   render();
 });
 $('#pcwb-back').onchange=e=>{state.back=e.target.checked;render()};
 $('#pcwb-sleeve').onchange=e=>{state.sleeve=e.target.checked;render()};
 $('#pcwb-accreditation').onchange=e=>{state.accreditation=e.target.value;render()};
 $$('input[name="pcwb-sleeve-side"]').forEach(x=>x.onchange=()=>{state.sleeveSide=x.value;render()});
 $$('input[name="pcwb-sleeve-method"]').forEach(x=>x.onchange=()=>{state.sleeveMethod=x.value;render()});
 $$('input[name="pcwb-service"]').forEach(x=>x.onchange=()=>{state.service=x.value;render()});
 $$('[data-start]').forEach(x=>x.onclick=()=>{
   kitTarget=null;
   setCategory(x.dataset.start,true);
 });
 const kitClear=$('#pcwb-kit-clear');
 if(kitClear)kitClear.onclick=()=>{
   activeKit=null;kitTarget=null;renderKit();
   const u=new URL(location.href);u.searchParams.delete('kit');history.replaceState({},'',u);
 };

 $('#pcwb-add-order').onclick=async()=>{
  const n=qty(state),p=currentPools();
  if(!n||(state.method==='embroidery'&&p.breastEmb<6)||(state.sleeve&&state.sleeveMethod==='embroidery'&&p.sleeveEmb<6))return;

  const wasEditing=state.editing!==null;
  const line={...state,sizes:{...state.sizes},qty:n}; delete line.editing;
  const lineHasEmb=line.method==='embroidery'||(line.sleeve&&line.sleeveMethod==='embroidery');
  if(lineHasEmb){
    if(!orderEmbSetup)orderEmbSetup=line.embSetup||state.embSetup||'new';
    line.embSetup=orderEmbSetup;
  }
  if(state.editing===null)order.push(line);else order[state.editing]=line;
  state.editing=null;

  // A saved line now lives safely in the order. For a NEW addition, clear the
  // size quantities so reopening this garment starts at zero instead of making
  // the customer manually remove the quantities they just added.
  // EDIT still restores the saved quantities via editLine().
  if(!wasEditing) resetSizes();
  renderDynamicOptions();
  render();

  // Guided recommended-kit flow:
  // after adding a garment, move straight to the next incomplete garment
  // instead of dropping the customer down to the order / "Add More Workwear" area.
  if(activeKit&&!wasEditing&&KITS[activeKit]){
    const next=KITS[activeKit].items.find(item=>kitOrderedQty(item.category)<item.qty);
    if(next){
      kitTarget={category:next.category,qty:next.qty};
      await setCategory(next.category,true);
      renderKit();
      render();
      return;
    }
  }

  $('#pcwb-order').scrollIntoView({behavior:'smooth',block:'start'});
 };

 const modal=$('#pcwb-size-modal');

function openSize(){
  if(modal) modal.hidden=false;
}

function closeSize(){
  if(modal) modal.hidden=true;
}

const sizeGuideBtn=$('#pcwb-size-guide-open-2');
const sizeGuideClose=$('.pcwb-modal-close');

if(sizeGuideBtn){
  sizeGuideBtn.onclick=openSize;
}

if(sizeGuideClose){
  sizeGuideClose.onclick=closeSize;
}

if(modal){
  modal.onclick=e=>{
    if(e.target===modal) closeSize();
  };
}

 // Shopify checkout connection.
 function tierLabel(table,n){
  const x=table.find(t=>n>=t.min&&n<=t.max);
  return x?`${x.min}${x.max>=99999?'+':'–'+x.max}`:null;
 }
 async function loadService(key){
  if(serviceProducts[key])return serviceProducts[key];
  const handle=SERVICES[key];
  const r=await fetch('/products/'+handle+'.js?pcwb='+Date.now(),{cache:'no-store'});
  if(!r.ok)throw new Error('Could not load service product: '+handle);
  serviceProducts[key]=await r.json();
  return serviceProducts[key];
 }
 function serviceVariant(product,table,n){
  if(!product||!product.variants||!product.variants.length)return null;
  if(!table)return product.variants[0];
  const wanted=tierLabel(table,n);
  const normal=s=>String(s||'').toLowerCase().replace(/\s/g,'').replace(/[–—]/g,'-');
  return product.variants.find(v=>{
    const text=[v.title,...(v.options||[])].join(' ');
    const t=normal(text);
    if(n>=50)return /50\+|50plus/.test(t);
    if(n>=25)return /25-49/.test(t);
    if(n>=10)return /10-24/.test(t);
    if(n>=6&&table===EMB)return /6-9/.test(t);
    if(n>=5)return /5-9/.test(t);
    return /1-4/.test(t);
  })||null;
 }
 function addCartItem(items,id,quantity,properties){
  if(!id||!quantity)return;
  items.push({id:+id,quantity:+quantity,properties:properties||{}});
 }
 async function buildShopifyCart(){
  if(!order.length)return;
  const btn=$('#pcwb-checkout');
  const oldText=btn.textContent;
  btn.disabled=true;btn.classList.add('disabled');btn.textContent='BUILDING YOUR ORDER…';
  try{
    const pools=decorationPools(false);
    const items=[];

    // Garments: preserve each exact Shopify colour/size variant.
    for(const line of order){
      const cfg=line.category==='tshirts'&&line.material==='cool'
        ? CATALOG.tshirts.cool
        : CATALOG[line.category][line.tier];
      const key=line.category==='tshirts'&&line.material==='cool'
        ? 'tshirts:cool'
        : line.category+':'+line.tier;
      let product=products[key];
      if(!product){
        const r=await fetch('/products/'+cfg.handle+'.js?pcwb='+Date.now(),{cache:'no-store'});
        if(!r.ok)throw new Error('Could not load garment: '+cfg.handle);
        product=products[key]=await r.json();
      }
      for(const [size,count] of Object.entries(line.sizes||{})){
        if(!count)continue;
        const variant=variantFor(product,line.colour,size);
        if(!variant)throw new Error(`No Shopify variant found for ${line.colour} / ${size}`);
        addCartItem(items,variant.id,count,{
          '_Builder':'Print Chimp Workwear',
          'Branding':[
            line.method==='embroidery'?'Left Breast Embroidery':'Left Breast Print',
            line.back?'Large Back Print':null,
            line.sleeve?`${line.accreditation} · ${line.sleeveSide} Sleeve · ${line.sleeveMethod==='embroidery'?'Embroidery':'Print'}`:null
          ].filter(Boolean).join(' · ')
        });
      }
    }

    // Decoration products are pooled across the whole order, matching builder pricing.
    if(pools.breastPrint){
      const pr=await loadService('breastPrint'),v=serviceVariant(pr,BREAST,pools.breastPrint);
      if(!v)throw new Error('Could not match Left Breast Print quantity tier');
      addCartItem(items,v.id,pools.breastPrint,{'Position':'Left Breast','_Artwork':'Logo supplied after ordering'});
    }
    if(pools.breastEmb){
      const pr=await loadService('breastEmb'),v=serviceVariant(pr,EMB,pools.breastEmb);
      if(!v)throw new Error('Could not match Left Breast Embroidery quantity tier');
      addCartItem(items,v.id,pools.breastEmb,{'Position':'Left Breast','_Artwork':'Logo supplied after ordering'});
    }
    if(pools.back){
      const pr=await loadService('backPrint'),v=serviceVariant(pr,BACK,pools.back);
      if(!v)throw new Error('Could not match Large Back Print quantity tier');
      addCartItem(items,v.id,pools.back,{'Position':'Large Back','_Artwork':'Logo supplied after ordering'});
    }

    // Sleeve services can carry different accreditation/side instructions, so group by those details.
    const sleeveGroups={};
    order.filter(x=>x.sleeve).forEach(x=>{
      const method=x.sleeveMethod==='embroidery'?'embroidery':'print';
      const k=[method,x.sleeveSide||'Left',x.accreditation||'Accreditation'].join('|');
      if(!sleeveGroups[k])sleeveGroups[k]={method,side:x.sleeveSide||'Left',accreditation:x.accreditation||'Accreditation',qty:0};
      sleeveGroups[k].qty+=(+x.qty||0);
    });
    for(const g of Object.values(sleeveGroups)){
      const poolQty=g.method==='embroidery'?pools.sleeveEmb:pools.sleevePrint;
      const table=g.method==='embroidery'?EMB:SLEEVE;
      const key=g.method==='embroidery'?'sleeveEmb':'sleevePrint';
      const pr=await loadService(key),v=serviceVariant(pr,table,poolQty);
      if(!v)throw new Error('Could not match Sleeve '+(g.method==='embroidery'?'Embroidery':'Print')+' quantity tier');
      addCartItem(items,v.id,g.qty,{
        'Sleeve':g.side,
        'Accreditation':g.accreditation,
        '_Artwork':'Confirmed after ordering'
      });
    }

    // One setup charge if this order contains a new embroidery logo.
    if(embroiderySetupTotal(order)){
      const pr=await loadService('embSetup');
      addCartItem(items,pr.variants[0].id,1,{'Setup':'New embroidery logo'});
    }

    // Production upgrade is charged once per garment.
    const garmentQty=order.reduce((sum,x)=>sum+(+x.qty||0),0);
    if(state.service==='fast'){
      const pr=await loadService('fast');
      addCartItem(items,pr.variants[0].id,garmentQty,{'Service':'Fast · 5–7 working days from artwork approval'});
    }else if(state.service==='express'){
      const pr=await loadService('express');
      addCartItem(items,pr.variants[0].id,garmentQty,{'Service':'Express · 3–5 working days from artwork approval'});
    }

    // Start with a clean cart so old unrelated items cannot distort this configured order.
    let r=await fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'}});
    if(!r.ok)throw new Error('Could not prepare Shopify cart');

    r=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items})
    });
    if(!r.ok){
      let detail='';
      try{detail=(await r.json()).description||''}catch(e){}
      throw new Error(detail||'Shopify could not add the configured order');
    }
    window.location.href='/cart';
  }catch(err){
    console.error('Print Chimp checkout:',err);
    alert('We could not build your Shopify cart. '+err.message+'. Please check the service product handles/variants and try again.');
    btn.disabled=false;btn.classList.remove('disabled');btn.textContent=oldText;
  }
 }
 $('#pcwb-checkout').onclick=buildShopifyCart;

 async function init(){
  const params=new URLSearchParams(location.search);
  const trade=params.get('trade')||params.get('industry');
  const kit=params.get('kit');
  const start=params.get('start')||'tshirts';

  tradePersonalise(trade);
  activeKit=KITS[kit]?kit:null;

  if(activeKit){
    const first=KITS[activeKit].items[0];
    kitTarget={category:first.category,qty:first.qty};
    await setCategory(first.category,false);
    renderKit();
    $('#pcwb-kit').scrollIntoView({behavior:'smooth',block:'start'});
  }else{
    await setCategory(CATALOG[start]?start:'tshirts',false);
  }
 }
 init();
})();
